import { Treatment } from "./../models/treatment";
import { Sorter, Accessor } from "./../collections/sortable-collection";

import {SortDictionary} from "../collections/sortable-collection";

export interface SortDictionaryDefinition {
    Name: string;
    Comparator: string;
    Accessor: string;
}

export const SorterDefinitionDictionary: {[id: string]: Sorter} = {
    CitedCasePriority : (n: any) => [n.CitedCasePriority, n.Treatment.Name],
    CourtWeightThenName: (n: any) => [n.Court.Weight, n.Court.Name],
    InverseYear: (n: any) => [9007199254740991 - parseInt(n.Year)],
    Jurisdiction: (n: any) => [n.DisplayJurisdiction],
    Title: (n: any) => [n.Title],
    CitingCasePriority: (n: any) => [n.CitingCasePriority, n.Treatment.Name],
    EU_Descriptor: (n: any) => [n.DocumentType],
    Sector: (n: any) => [n.get("SectorNumber")],
    EU_RelationDescription: (n: any) => [n.get("Description")]
};

export const AccessorDefinitionDictionary: {[id: string]: Accessor} = {
    TreatmentName: (n: any) => `<h3 class="treatment-label ${n.Treatment.Type}" title="${n.Treatment.Description}">${n.Treatment.Name}</h3>`,
    CourtName : (n: any) => `<h2 class="heading"><img src="assets/images/flags/32/${n.IconUrl}" />${n.Court.Name}</h2>`,
    Year : (n: any) => n.Year === "1" ? "" : "" + `<h2 class="heading">${n.Year}</h2>`, // If related document year is 1, then the heading is empty.
    Jurisdiction: (n: any) => `<h2 class="collapse-heading" data-collapse="DisplayJurisdiction" data-value="${n.DisplayJurisdiction}"><img src="assets/images/flags/32/${n.IconUrl}" />${n.DisplayJurisdiction}</h2>`,
    Title: (n: any) => "",
    EU_Descriptor: (n: any) => `<h2 class="heading">${n.get("DocumentType")}</h2>`,
    Sector: (n: any) => `<h2 class="heading">${n.get("SectorName")}</h2>`,
    EU_RelationDescription: (n: any) => `<h2 class="heading">${n.get("Description")}</h2>`,
};



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/helpers/sorter-definition-dictionary.ts